
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.632 4.871c.25-.492.856-.691 1.317-.388a9 9 0 11-9.898 0c.46-.303 1.066-.103 1.317.388.25.492.05 1.088-.402 1.406a7.002 7.002 0 108.068 0c-.451-.318-.652-.914-.402-1.406z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2a1 1 0 011 1v5a1 1 0 11-2 0V3a1 1 0 011-1z"}})])
          )
        }
      }
    